module.exports = __webpack_public_path__ + "media/images/admin/icons/life-buoy-f2aeaeaf64fbc44f283112d92dbfbfdb.svg";